import { PAYMENT_GATEWAYS_API } from 'modules/profile/payment-gateways/api/payment-gateways-api'
import { PaymentMollieProfileApiInterface } from 'modules/profile/payment-gateways/integrations/mollie/types'
import useUser from 'shared/hooks/use-user'
import { baseFetcher } from 'shared/utils/http-client'
import useSWR from 'swr'

export function useMollieProfiles(shouldFetch: boolean) {
  const { user } = useUser()
  return useSWR<PaymentMollieProfileApiInterface>(() => {
    if (user && shouldFetch) {
      return `${PAYMENT_GATEWAYS_API}/mollie/list-profiles`
    }
    return null
  }, baseFetcher)
}
